<template>
  <div class="p-4">
    <div v-if="!showManageRequest">
      <b-row>
        <b-col class="mb-2 text-center" cols="12" lg="3" md="12" sm="12" xl="3">
          <access-manager-card :menuOption.sync="menuOption"></access-manager-card>
        </b-col>
        <b-col cols="12" lg="9" md="12" sm="12" xl="9">
          <component
            :is="menuOption"
            :canManageAccess="canManageAccess"
            :siteId="siteId"
            :studyId="studyId"
            :studySite="studySite"
            @myAccessRequests="myAccessRequests = $event"
            @myTeam="teamMembers = $event"
            @redirectToOldCAM="redirectToOldCAM"
            @showManageRequest="showManageRequest = true"
          ></component>
        </b-col>
      </b-row>
    </div>
    <div v-if="showManageRequest">
      <manage-request
        :myAccessRequests="myAccessRequests"
        :siteId="siteId"
        :studyId="studyId"
        :teamMembers="teamMembers"
        :studySite="studySite"
        @hideManageRequest="hideManageRequest()"
      ></manage-request>
    </div>
  </div>
</template>

<script>
  import tableFieldsMixin from '../../mixins/tableFieldsMixin';
  import ManageRequest from '../ManageRequest';
  import MyAccess from './MyAccess';
  import MyTeam from './MyTeam';
  import ViewStudyAccessRequests from './ViewStudyAccessRequests.vue';
  import AccessManagerCard from './AccessManagerCard';
  import { mapGetters } from 'vuex';

  export default {
    mixins: [tableFieldsMixin],
    components: {
      ManageRequest,
      MyAccess,
      MyTeam,
      ViewStudyAccessRequests,
      AccessManagerCard,
    },
    props: {
      blockedModules: Array,
      studySite: Object,
    },
    metaInfo() {
      let metaTitle = this.$appName + this.studyId + '-' + this.siteId + ' Application Access';
      return {
        title: metaTitle,
      };
    },
    data() {
      return {
        menuOption: 'my-access',
        studyId: '',
        siteId: '',
        showManageRequest: false,
        myAccessRequests: [],
        teamMembers: [],
      };
    },
    computed: {
      ...mapGetters(['userDetails']),
      canManageAccess() {
        return !this.blockedModules.includes('Application Access Manager');
      },
    },
    watch: {
      $route() {
        this.setupStudySiteIds();
        this.selectAccessMenu();
      },
    },
    created() {
      this.selectAccessMenu();
      this.setupStudySiteIds();
    },
    methods: {
      redirectToOldCAM() {
        window.open('https://prep.pfizer.com', '_blank');
      },
      setupStudySiteIds() {
        this.showManageRequest = false;
        this.studyId = this.$route.params['studyId'];
        this.siteId = this.$route.params['siteId'];
      },
      selectAccessMenu() {
        if (this.$route.query.option) {
          this.menuOption = this.$route.query.option;
        }
      },
      hideManageRequest() {
        this.showManageRequest = false;
        this.$store.commit('setUserDetails', {});
      },
    },
  };
</script>

<style>
  .header-info-text {
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #4040d7;
  }
  .table-row-text {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: #49454f;
  }

  .add-member {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #ffffff;
  }
  .my-team-table-header {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
  }

  .my-access-table-header {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
    letter-spacing: 0.25px;
  }

  .my-team-striped .table-striped tbody tr:nth-of-type(odd) {
    background-color: #f7f8f8;
  }

  .thMyTeam {
    background: #f4eff4;
  }
</style>
